const defaultSearchOptions = {
    language: 'en',
    fuzzyMatch: true,
    minScore: 0.1,
    maxResults: 20
};
// Keyword translations for different languages
const keywordTranslations = {
    en: {
        'gps': ['gps', 'location', 'position', 'signal'],
        'weather': ['weather', 'forecast', 'temperature', 'rain', 'sun'],
        'tides': ['tides', 'tide', 'water', 'ocean', 'sea'],
        'settings': ['settings', 'configure', 'options', 'setup'],
        'permissions': ['permissions', 'access', 'privacy', 'data'],
        'pro': ['pro', 'premium', 'key', 'unlock', 'crown'],
        'installation': ['install', 'setup', 'download', 'queue'],
        'troubleshooting': ['problem', 'error', 'issue', 'fix', 'help']
    },
    de: {
        'gps': ['gps', 'standort', 'position', 'signal'],
        'weather': ['wetter', 'vorhersage', 'temperatur', 'regen', 'sonne'],
        'tides': ['gezeiten', 'wasser', 'ozean', 'meer'],
        'settings': ['einstellungen', 'konfigurieren', 'optionen', 'setup'],
        'permissions': ['berechtigungen', 'zugriff', 'datenschutz', 'daten'],
        'pro': ['pro', 'premium', 'schlüssel', 'freischalten', 'krone'],
        'installation': ['installation', 'setup', 'download', 'warteschlange'],
        'troubleshooting': ['problem', 'fehler', 'issue', 'reparieren', 'hilfe']
    },
    fr: {
        'gps': ['gps', 'localisation', 'position', 'signal'],
        'weather': ['météo', 'prévision', 'température', 'pluie', 'soleil'],
        'tides': ['marées', 'eau', 'océan', 'mer'],
        'settings': ['paramètres', 'configurer', 'options', 'configuration'],
        'permissions': ['permissions', 'accès', 'confidentialité', 'données'],
        'pro': ['pro', 'premium', 'clé', 'débloquer', 'couronne'],
        'installation': ['installation', 'configuration', 'téléchargement', 'file'],
        'troubleshooting': ['problème', 'erreur', 'issue', 'réparer', 'aide']
    },
    es: {
        'gps': ['gps', 'ubicación', 'posición', 'señal'],
        'weather': ['clima', 'pronóstico', 'temperatura', 'lluvia', 'sol'],
        'tides': ['mareas', 'agua', 'océano', 'mar'],
        'settings': ['configuración', 'configurar', 'opciones', 'ajustes'],
        'permissions': ['permisos', 'acceso', 'privacidad', 'datos'],
        'pro': ['pro', 'premium', 'clave', 'desbloquear', 'corona'],
        'installation': ['instalación', 'configuración', 'descarga', 'cola'],
        'troubleshooting': ['problema', 'error', 'issue', 'reparar', 'ayuda']
    },
    it: {
        'gps': ['gps', 'posizione', 'localizzazione', 'segnale'],
        'weather': ['meteo', 'previsione', 'temperatura', 'pioggia', 'sole'],
        'tides': ['maree', 'acqua', 'oceano', 'mare'],
        'settings': ['impostazioni', 'configurare', 'opzioni', 'setup'],
        'permissions': ['permessi', 'accesso', 'privacy', 'dati'],
        'pro': ['pro', 'premium', 'chiave', 'sbloccare', 'corona'],
        'installation': ['installazione', 'configurazione', 'download', 'coda'],
        'troubleshooting': ['problema', 'errore', 'issue', 'riparare', 'aiuto']
    },
    pt: {
        'gps': ['gps', 'localização', 'posição', 'sinal'],
        'weather': ['clima', 'previsão', 'temperatura', 'chuva', 'sol'],
        'tides': ['marés', 'água', 'oceano', 'mar'],
        'settings': ['configurações', 'configurar', 'opções', 'ajustes'],
        'permissions': ['permissões', 'acesso', 'privacidade', 'dados'],
        'pro': ['pro', 'premium', 'chave', 'desbloquear', 'coroa'],
        'installation': ['instalação', 'configuração', 'download', 'fila'],
        'troubleshooting': ['problema', 'erro', 'issue', 'reparar', 'ajuda']
    },
    nl: {
        'gps': ['gps', 'locatie', 'positie', 'signaal'],
        'weather': ['weer', 'voorspelling', 'temperatuur', 'regen', 'zon'],
        'tides': ['getijden', 'water', 'oceaan', 'zee'],
        'settings': ['instellingen', 'configureren', 'opties', 'setup'],
        'permissions': ['machtigingen', 'toegang', 'privacy', 'gegevens'],
        'pro': ['pro', 'premium', 'sleutel', 'ontgrendelen', 'kroon'],
        'installation': ['installatie', 'configuratie', 'download', 'wachtrij'],
        'troubleshooting': ['probleem', 'fout', 'issue', 'repareren', 'hulp']
    },
    pl: {
        'gps': ['gps', 'lokalizacja', 'pozycja', 'sygnał'],
        'weather': ['pogoda', 'prognoza', 'temperatura', 'deszcz', 'słońce'],
        'tides': ['pływy', 'woda', 'ocean', 'morze'],
        'settings': ['ustawienia', 'konfiguracja', 'opcje', 'setup'],
        'permissions': ['uprawnienia', 'dostęp', 'prywatność', 'dane'],
        'pro': ['pro', 'premium', 'klucz', 'odblokować', 'korona'],
        'installation': ['instalacja', 'konfiguracja', 'pobieranie', 'kolejka'],
        'troubleshooting': ['problem', 'błąd', 'issue', 'naprawić', 'pomoc']
    },
    cs: {
        'gps': ['gps', 'poloha', 'pozice', 'signál'],
        'weather': ['počasí', 'předpověď', 'teplota', 'déšť', 'slunce'],
        'tides': ['přílivy', 'voda', 'oceán', 'moře'],
        'settings': ['nastavení', 'konfigurace', 'možnosti', 'setup'],
        'permissions': ['oprávnění', 'přístup', 'soukromí', 'data'],
        'pro': ['pro', 'premium', 'klíč', 'odemknout', 'koruna'],
        'installation': ['instalace', 'konfigurace', 'stahování', 'fronta'],
        'troubleshooting': ['problém', 'chyba', 'issue', 'opravit', 'pomoc']
    },
    ja: {
        'gps': ['gps', '位置', 'ポジション', '信号'],
        'weather': ['天気', '予報', '温度', '雨', '太陽'],
        'tides': ['潮汐', '水', '海', '海洋'],
        'settings': ['設定', '構成', 'オプション', 'セットアップ'],
        'permissions': ['権限', 'アクセス', 'プライバシー', 'データ'],
        'pro': ['プロ', 'プレミアム', 'キー', 'アンロック', 'クラウン'],
        'installation': ['インストール', '設定', 'ダウンロード', 'キュー'],
        'troubleshooting': ['問題', 'エラー', 'issue', '修復', 'ヘルプ']
    },
    ko: {
        'gps': ['gps', '위치', '포지션', '신호'],
        'weather': ['날씨', '예보', '온도', '비', '태양'],
        'tides': ['조수', '물', '바다', '해양'],
        'settings': ['설정', '구성', '옵션', '셋업'],
        'permissions': ['권한', '접근', '개인정보', '데이터'],
        'pro': ['프로', '프리미엄', '키', '잠금해제', '크라운'],
        'installation': ['설치', '구성', '다운로드', '큐'],
        'troubleshooting': ['문제', '오류', 'issue', '수리', '도움']
    },
    zh: {
        'gps': ['gps', '位置', '位置', '信号'],
        'weather': ['天气', '预报', '温度', '雨', '太阳'],
        'tides': ['潮汐', '水', '海洋', '海'],
        'settings': ['设置', '配置', '选项', '设置'],
        'permissions': ['权限', '访问', '隐私', '数据'],
        'pro': ['专业', '高级', '密钥', '解锁', '皇冠'],
        'installation': ['安装', '配置', '下载', '队列'],
        'troubleshooting': ['问题', '错误', 'issue', '修复', '帮助']
    }
};
// Fuzzy string matching using Levenshtein distance
function levenshteinDistance(str1, str2) {
    const matrix = Array(str2.length + 1).fill(null).map(() => Array(str1.length + 1).fill(null));
    for (let i = 0; i <= str1.length; i++)
        matrix[0][i] = i;
    for (let j = 0; j <= str2.length; j++)
        matrix[j][0] = j;
    for (let j = 1; j <= str2.length; j++) {
        for (let i = 1; i <= str1.length; i++) {
            const indicator = str1[i - 1] === str2[j - 1] ? 0 : 1;
            matrix[j][i] = Math.min(matrix[j][i - 1] + 1, matrix[j - 1][i] + 1, matrix[j - 1][i - 1] + indicator);
        }
    }
    return matrix[str2.length][str1.length];
}
// Calculate similarity score between two strings
function calculateSimilarity(str1, str2) {
    const distance = levenshteinDistance(str1.toLowerCase(), str2.toLowerCase());
    const maxLength = Math.max(str1.length, str2.length);
    return maxLength === 0 ? 1 : (maxLength - distance) / maxLength;
}
// Get translated keywords for a language
function getTranslatedKeywords(keyword, language) {
    const translations = keywordTranslations[language] || keywordTranslations['en'];
    return translations[keyword] || [keyword];
}
// Search function
export function searchFAQ(query, items, options = {}) {
    const opts = { ...defaultSearchOptions, ...options };
    const results = [];
    if (!query.trim())
        return results;
    const queryWords = query.toLowerCase().split(/\s+/);
    for (const item of items) {
        let score = 0;
        const matchedKeywords = [];
        const matchedText = [];
        // Check question match
        const questionWords = item.question.toLowerCase().split(/\s+/);
        for (const queryWord of queryWords) {
            for (const questionWord of questionWords) {
                if (opts.fuzzyMatch) {
                    const similarity = calculateSimilarity(queryWord, questionWord);
                    if (similarity > 0.6) {
                        score += similarity * 2;
                        matchedText.push(questionWord);
                    }
                }
                else if (questionWord.includes(queryWord) || queryWord.includes(questionWord)) {
                    score += 2;
                    matchedText.push(questionWord);
                }
            }
        }
        // Check answer match
        const answerWords = item.answer.toLowerCase().split(/\s+/);
        for (const queryWord of queryWords) {
            for (const answerWord of answerWords) {
                if (opts.fuzzyMatch) {
                    const similarity = calculateSimilarity(queryWord, answerWord);
                    if (similarity > 0.6) {
                        score += similarity;
                        matchedText.push(answerWord);
                    }
                }
                else if (answerWord.includes(queryWord) || queryWord.includes(answerWord)) {
                    score += 1;
                    matchedText.push(answerWord);
                }
            }
        }
        // Check keyword matches
        for (const keyword of item.keywords) {
            for (const queryWord of queryWords) {
                // Check original keyword
                if (opts.fuzzyMatch) {
                    const similarity = calculateSimilarity(queryWord, keyword);
                    if (similarity > 0.6) {
                        score += similarity * 3;
                        matchedKeywords.push(keyword);
                    }
                }
                else if (keyword.includes(queryWord) || queryWord.includes(keyword)) {
                    score += 3;
                    matchedKeywords.push(keyword);
                }
                // Check translated keywords
                const translatedKeywords = getTranslatedKeywords(keyword, opts.language);
                for (const translatedKeyword of translatedKeywords) {
                    if (opts.fuzzyMatch) {
                        const similarity = calculateSimilarity(queryWord, translatedKeyword);
                        if (similarity > 0.6) {
                            score += similarity * 3;
                            matchedKeywords.push(translatedKeyword);
                        }
                    }
                    else if (translatedKeyword.includes(queryWord) || queryWord.includes(translatedKeyword)) {
                        score += 3;
                        matchedKeywords.push(translatedKeyword);
                    }
                }
            }
        }
        // Apply priority multiplier
        score *= (item.priority / 5);
        if (score >= opts.minScore) {
            results.push({
                item,
                score,
                matchedKeywords: [...new Set(matchedKeywords)],
                matchedText: [...new Set(matchedText)].join(' ')
            });
        }
    }
    // Sort by score (highest first) and limit results
    return results
        .sort((a, b) => b.score - a.score)
        .slice(0, opts.maxResults);
}
// Get search suggestions based on popular queries
export function getSearchSuggestions(language = 'en') {
    const suggestions = {
        en: [
            'GPS fix',
            'Weather data',
            'Pro features',
            'Settings',
            'Installation',
            'Permissions',
            'Tides',
            'Time format',
            'Temperature units'
        ],
        de: [
            'GPS Fix',
            'Wetterdaten',
            'Pro Funktionen',
            'Einstellungen',
            'Installation',
            'Berechtigungen',
            'Gezeiten',
            'Zeitformat',
            'Temperatureinheiten'
        ],
        fr: [
            'Fix GPS',
            'Données météo',
            'Fonctions pro',
            'Paramètres',
            'Installation',
            'Permissions',
            'Marées',
            'Format heure',
            'Unités température'
        ],
        es: [
            'Fix GPS',
            'Datos clima',
            'Funciones pro',
            'Configuración',
            'Instalación',
            'Permisos',
            'Mareas',
            'Formato hora',
            'Unidades temperatura'
        ],
        it: [
            'Fix GPS',
            'Dati meteo',
            'Funzioni pro',
            'Impostazioni',
            'Installazione',
            'Permessi',
            'Maree',
            'Formato ora',
            'Unità temperatura'
        ],
        pt: [
            'Fix GPS',
            'Dados clima',
            'Recursos pro',
            'Configurações',
            'Instalação',
            'Permissões',
            'Marés',
            'Formato hora',
            'Unidades temperatura'
        ],
        nl: [
            'GPS fix',
            'Weergegevens',
            'Pro functies',
            'Instellingen',
            'Installatie',
            'Machtigingen',
            'Getijden',
            'Tijdformaat',
            'Temperatuureenheden'
        ],
        pl: [
            'Fix GPS',
            'Dane pogodowe',
            'Funkcje pro',
            'Ustawienia',
            'Instalacja',
            'Uprawnienia',
            'Pływy',
            'Format czasu',
            'Jednostki temperatury'
        ],
        cs: [
            'GPS fix',
            'Meteorologická data',
            'Pro funkce',
            'Nastavení',
            'Instalace',
            'Oprávnění',
            'Přílivy',
            'Formát času',
            'Teplotní jednotky'
        ],
        ja: [
            'GPS修正',
            '天気データ',
            'プロ機能',
            '設定',
            'インストール',
            '権限',
            '潮汐',
            '時間形式',
            '温度単位'
        ],
        ko: [
            'GPS 수정',
            '날씨 데이터',
            '프로 기능',
            '설정',
            '설치',
            '권한',
            '조수',
            '시간 형식',
            '온도 단위'
        ],
        zh: [
            'GPS修复',
            '天气数据',
            '专业功能',
            '设置',
            '安装',
            '权限',
            '潮汐',
            '时间格式',
            '温度单位'
        ]
    };
    return suggestions[language] || suggestions['en'];
}
// Get trending/popular search terms
export function getTrendingSearches() {
    return [
        'GPS fix',
        'Weather not working',
        'Pro features',
        'Settings not loading',
        'Installation fails',
        'Permission denied',
        'Tides setup',
        'Time format change',
        'Temperature units',
        'Watchface not found'
    ];
}
